<div class="main-wrapper">
  <section aria-label="Review step section" *ngIf="authenticatepage && pageContent" class="signup-review-section">
    <div *ngIf="showError" id="alertMessage" class="alert valign-children-middle">
      <div class="alert-error" role="img" aria-label="Error">
        <i class="icon-badgealert"></i>
      </div>
      <div>
        <span>{{errorMessage}}</span>
      </div>
    </div>
    <h2>{{pageContent.heading}}</h2>
    <div *ngIf="changeEnrollmentSettings">
        <div *ngFor="let page of pageDescription">
         <div *ngIf="!page.hide">
         <h3> {{page.header}} </h3>
       <div class="list-container" *ngIf="page.gridOptions">
        <div *ngIf="page.accordion" class="accordion-grid">
          <div *ngIf="page.moreThanFiveFan">
          <app-accordion *ngIf="page.accordion" [accordion]="page.accordion" [accordionController]=false >
            <app-accordion-list *ngFor="let FAN of page.accordion" [option]="FAN" [isSubAccordion]=true >
              <app-customgrid [gridOptions]="page.gridOptions" [mainAriaLAbel]="'Select all Foundation account numbers'" (onDataChange)="page.gridCallback($event)">
              </app-customgrid>
            </app-accordion-list>
          </app-accordion>
        </div>
        <div *ngIf="!page.moreThanFiveFan">
        <app-customgrid [gridOptions]="page.gridOptions" [mainAriaLAbel]="'Select all Foundation account numbers'" (onDataChange)="page.gridCallback($event)">
          </app-customgrid>
          </div>
        </div>
        <div *ngIf="!page.accordion">
          <h4>{{page.gridHeader}}</h4>
          <app-customgrid [gridOptions]="page.gridOptions" [mainAriaLAbel]="'Select all Foundation account numbers'" (onDataChange)="page.gridCallback($event)">
          </app-customgrid>
        </div>
      </div>
      </div>
      </div>
    </div>
    <div  *ngIf="!changeEnrollmentSettings">
    <section aria-label="Selectd FAN list" *ngIf="accordion" class="fanlist-with-accordion">
      <app-accordion [accordion]="tabArray" [accordionController]=false>
        <app-accordion-list *ngFor="let option of tabArray; let i = index" [option]='option' [isSubAccordion]=true>
          <p>{{pageContent.selectFANLabel}}</p>
          <app-customgrid [gridOptions]="gridOptions" [mainAriaLAbel]="'Select all Foundation account numbers'" (onDataChange)="onRowClick($event)"></app-customgrid>
        </app-accordion-list>
      </app-accordion>
    </section>
    <section aria-label="Selectd FAN list" *ngIf="!accordion" class="fanlist-without-accordion">
      <p>{{signupOutputData.FANList[selectedFan].length}} {{displayFANText}}</p>
      <app-customgrid [gridOptions]="gridOptions" [mainAriaLAbel]="'Select all Foundation account numbers'" (onDataChange)="onRowClick($event)"></app-customgrid>
    </section>
    </div>
    <section aria-labelledby="MDMserviceheading" class="service-type">
      <h3 id="MDMserviceheading">{{pageContent.MDMService.heading}}</h3>
      <p><span class="label-review">{{pageContent.MDMService.label}}: </span><span [innerHTML]="OemHeading"></span></p>
      <p *ngIf="selectedGoogleID"><span class="label-review">{{pageContent.MDMService.googleIdLabel1}}{{pageContent.MDMService.googleIdLabel2}}: </span>{{selectedGoogleID}}</p>
      <p *ngIf="selectedSamsungID"><span class="label-review">{{pageContent.MDMService.samsungLabel}}: </span>{{selectedSamsungID}}</p>
    </section>
   
    <section aria-labelledby="reviewSettings" class="reviewsettings editable-container" [ngClass]="{'have-no-accordion': accordion}">
      <h3 id="reviewSettings">{{pageContent.settings.heading}} <a href="#" aria-label="Review and change settings step" (click)="backToPrevious($event, 'settings')">{{pageContent.buttons.edit}}</a></h3>
      <div *ngIf="!oemStatus" class="networkpolicy">
        <p><span class="label-review">{{pageContent.settings.newDevNwLabel}}: </span>{{signupOutputData.profile.settings.newDevNwt ? pageContent.settings.onLabel:pageContent.settings.offLabel}}</p>
        <p><span class="label-review">{{pageContent.settings.extDevNwlabel}}: </span>{{signupOutputData.profile.settings.extDevNwt ? pageContent.settings.onLabel:pageContent.settings.offLabel}}</p>
      </div>
      <div *ngIf="!oemStatus" class="securitypolicy">
        <p><span class="label-review">{{pageContent.settings.securityPolicy}}: </span>{{signupOutputData.profile.settings.securityPolicy == 'SB' ? pageContent.settings.securitySB :pageContent.settings.securitySE}}</p>
        <p><span class="label-review">{{pageContent.settings.passcodePolicy}}: </span>{{signupOutputData.profile.settings.passCodePolicy == 'PB' ? pageContent.settings.passcodePB : signupOutputData.profile.settings.passCodePolicy == 'PS' ? pageContent.settings.passcodePS: pageContent.settings.passcodePN}}</p>
      </div>
      <div class="notifications">
        <p *ngIf="signupOutputData.profile.settings.emailEnabled && !signupOutputData.profile.settings.smsEnabled"><span class="label-review">{{pageContent.settings.notification}}: </span>{{pageContent.settings.emailLabel}}</p>
        <p *ngIf="!signupOutputData.profile.settings.emailEnabled && signupOutputData.profile.settings.smsEnabled"><span class="label-review">{{pageContent.settings.notification}}: </span>{{pageContent.settings.smsLabel}}</p>
        <p *ngIf="signupOutputData.profile.settings.emailEnabled && signupOutputData.profile.settings.smsEnabled"><span class="label-review">{{pageContent.settings.notification}}: </span>{{pageContent.settings.bothLabel}}</p>
      </div>
    </section>
    <section aria-labelledby="reviewApplications" *ngIf="!oemStatus" class="reviewapplications editable-container">
      <h3 id="reviewApplications">{{pageContent.applications}} <a href="#" aria-label="Review and change applications step" (click)="backToPrevious($event, 'applications')">{{pageContent.buttons.edit}}</a></h3>
      <ul>
        <li class="app-list" *ngFor="let app of selectedApps">
          {{app}}
        </li>
      </ul>
    </section>
    <section aria-labelledby="reviewEnrollmentDates" class="reviewenrolldate editable-container">
      <h3 id="reviewEnrollmentDates">{{pageContent.enrollDate.heading}} <a href="#" aria-label="Review and change enrollment date step" (click)="backToPrevious($event, 'startdate')">{{pageContent.buttons.edit}}</a></h3>
      <p><span class="label-review">{{pageContent.enrollDate.new}}: </span>{{signupOutputData.deviceEnrollDate.new | date: 'MM/dd/yyyy'}}</p>
      <p *ngIf="!existingDateNull"><span class="label-review">{{pageContent.enrollDate.existing}}: </span>{{signupOutputData.deviceEnrollDate.existing | date: 'MM/dd/yyyy'}}</p>
      <p *ngIf="existingDateNull"><span class="label-review">{{pageContent.enrollDate.existing}}: </span>{{pageContent.enrollDate.existingNullLabel}}</p>
    </section>
    <section aria-label="Alert Section" class="buttons-section col-sm-12 col-md-12">
      <h3 id="alertSection">{{pageContent.enrollDatePopup.topHeading}}</h3>
        <div class="row enrollDateInfo">
            <div class="alert-icon">
              <i aria-label="Alert" class="icon-alert .ico" role="img"></i>
            </div>
            <div class="extra-content">
              <span [innerHTML]="pageContent.enrollDatePopup.pageText"></span>
              <a href="javascript:void(0);" title ="Opens a dialog." aria-label="Learn more about device enrollment steps." (click)="showenroll()">{{pageContent.enrollDatePopup.pageLinkText}}</a>
            </div>
        </div>
      <div *ngIf='showEnrollDetailsModal'>
        <app-modal [showModal]="showEnrollDetailsModal">
          <app-confirm-modal [modalPopupObject]='enrollDatePopup' [triggerElement]='eventEmit' (modalOutput)="closeModal($event)">
          </app-confirm-modal>
        </app-modal>
      </div>
    </section>
    <section aria-labelledby="reviewUnderstandSecion" class="reviewunderstand">
      <h3 id="reviewUnderstandSecion">{{pageContent.acknowledge.heading}}</h3>
      <p>{{pageContent.acknowledge.description}}</p>
      <div class="google-acknowledge" *ngIf="emmProductCode === 'DMPGZTP'">
        <h3>Google<sup>®</sup>{{pageContent.acknowledge.googleTermsHeading}}</h3>
        <p>{{pageContent.acknowledge.googleTermsDescription}}Google<sup>®</sup>.</p>
      </div>
      <div class="check">
        <div class="checkbox" [ngClass]="{'error-text': showError && !is_acknowledged}">
          <label for="terms">
            <input (change)="is_acknowledged = !is_acknowledged" id="terms" type="checkbox"/><i class="skin"></i><span class="terms-understand">{{pageContent.acknowledge.understand}}</span>
          </label>
        </div>
      </div>
    </section>
    <section aria-label="Buttons section" class="buttons-section col-sm-12 col-md-12 text-right">
        <button id="review-btn" [checkImpersonator]="!is_acknowledged || showError" id="review-btn" (click)="confirmAndSubmit()" href="javascript:void(0)" 
        class="btn btn-secondary pull-right">{{pageContent.buttons.submit}}</button>
      <a href="#" (click)="backToPrevious($event, 'startdate')" class="btn btn-link btn-block btn-cancel review-btn-cancel">{{pageContent.buttons.back}}</a>
    </section>
    <div *ngIf='showSupportModal'>
      <app-modal [showModal]="showSupportModal">
        <app-confirm-modal [modalPopupObject]='mdmServicemodel' [triggerElement]='eventEmit' (modalOutput)="closeModal($event)">
        </app-confirm-modal>
      </app-modal>
    </div>
  </section>
</div>